import { parseIframeComponentFramework } from './component.iframe.component-framework.js';
import { parseIframeHtmlComponent } from './component.iframe.html.js';
import { parseIbook4Component } from './component.iframe.ibook4.js';
import { parseTaskEngineLinkComponent } from './component.iframe.task-engine-link.js';

const iframeComponentParsers = {
  component: parseIframeComponentFramework,
  ibook4: parseIbook4Component,
  iframe: parseIframeHtmlComponent,
  taskenginelink: parseTaskEngineLinkComponent
};

export { iframeComponentParsers };
//# sourceMappingURL=component.iframe.js.map
